// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"jq","image":"jr","contentContainer":"js","mainText":"jt","subText":"ju","counter":"jv"};